module.exports = __webpack_public_path__ + "img/support.44b0234c.svg";